import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { HybridToolsService } from '../../../../core/services/hybrid-tools.service';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['../participants-resources.scss']
})
export class DownloadsComponent implements AfterViewInit {
  @Input() downloads: any = {};
  constructor(private hybridToolsService: HybridToolsService) { }

  ngAfterViewInit() {
    const that = this;
    $('.downloads-links a').each(function (item) {
      $(this).attr('data-link', $(this).attr('href')).removeAttr('href');
      $(this).addClass('link');
      $(this).bind('click', function () {
        that.hybridToolsService.openExternalLink($(this).attr('data-link'));
      });
    });
  }

}
